jQuery(document).ready(function ($) {
  // init each swiper
  $('.castle-collection-slider').each(function (i, sliderEl) {
    var $slider = $(sliderEl);
    var $swiperEl = $slider.find('.castle-collection-swiper');
    var $actionEl = $slider.next('.castle-collection-slider-action'); // sibling action block

    // init swiper
    var swiper = new Swiper($swiperEl[0], {
     slidesPerView: 3, // fallback (desktop)
  spaceBetween: 30,
  loop: true,

  breakpoints: {
    0: {
      slidesPerView: 1.3, // mobile < 768px
    },
    768: {
      slidesPerView: 2.3, // tablet >= 768px
      spaceBetween: 57.2
    },
    1440: {
      slidesPerView: 2.3, // desktop >= 1440px
      spaceBetween: 57.2
    },
    1566: {
      slidesPerView: 2.3, // desktop >= 1440px
      spaceBetween: 57.2
    }
  }
    });

    // bind custom next
    $actionEl.find('.swiper-custom-next').on('click', function () {
      swiper.slideNext();
    });

    // (optional) if you add a prev later
    $actionEl.find('.swiper-custom-prev').on('click', function () {
      swiper.slidePrev();
    });
  });


    var swiperInstance;

    function initSwiper() {
        if ($(window).width() <= 800) {
            if (!$('.castle-all-features').hasClass('swiper-initialized')) {
                $('.castle-all-features').addClass('swiper');
                $('.all-feature').addClass('swiper-slide');

                // wrap features in swiper-wrapper
                if (!$('.castle-all-features .swiper-wrapper').length) {
                $('.castle-all-features').wrapInner('<div class="swiper-wrapper"></div>');
                }
                $('.castle-all-features').fadeIn();
                    swiperInstance = new Swiper('.castle-all-features', {
                    spaceBetween: 10,
                    loop: true,
                    allowTouchMove: false,
                    speed: 5000, // higher = slower
                    autoplay: {
                        delay: 0,
                        disableOnInteraction: false,
                    },
                    breakpoints: {
                        0: {
                        slidesPerView: 1, // ✅ for <= 566px
                        },
                        567: {
                        slidesPerView: 1.5, // ✅ for >= 567px
                        }
                    }
                });


                
              
            }
        } else {
            if (swiperInstance) {
                swiperInstance.destroy(true, true);
                swiperInstance = undefined;

                // unwrap slides back to normal
                $('.castle-all-features').removeClass('swiper');
                $('.all-feature').removeClass('swiper-slide');
                $('.castle-all-features .swiper-wrapper').contents().unwrap();
            }
        }
    }

    // init on load
    initSwiper();

    // re-init on resize
    $(window).on('resize', function () {
        initSwiper();
    });


    // // Section Hero Slider
    // new Swiper('.swiper-hero-slider', {
    //   effect: 'fade',
    //   fadeEffect: {
    //     crossFade: true
    //   },
    //   loop: true,
    //   autoplay: {
    //     delay: 3000, // 3 seconds
    //     disableOnInteraction: false
    //   },
    //   speed: 800
    // });


    new Swiper('.swiper-instagram-images', {
      slidesPerView: 4,  // default desktop
      spaceBetween: 0,   // no padding between slides
      breakpoints: {
        // when window width is >= 768px (tablet)
        768: {
          slidesPerView: 4,
          spaceBetween: 0
        },
        // when window width is < 768px (mobile)
        0: {
          slidesPerView: 3,
          spaceBetween: 0
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });



    function initZoomButtonForBed() {
      // Check if product title contains "Bed" (case-insensitive)
      const productTitle = $('.product-title').text() || '';
      if (!/bed/i.test(productTitle)) return; // exit if "Bed" not in title

      const selector = '.tpo_swatches-label_position.under.below_value.tpo_image-swatch-always';
      const intervalTime = 300; // check every 300ms
      const maxTime = 10000;     // stop after 5 seconds
      let elapsed = 0;

      const checkInterval = setInterval(function () {
        const $el = $(selector);

        if ($el.length) {
          // Append Zoom button if not already added
          if (!$el.find('.tpo-zoom-btn').length) {
            const svgZoom = `
              <button type="button" class="tpo-zoom-btn" title="Zoom">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </button>
            `;
            $el.append(svgZoom);
          }

          clearInterval(checkInterval); // stop once element is found

  
          return;
        }

        elapsed += intervalTime;

        // Stop interval after maxTime
        if (elapsed >= maxTime) {
          clearInterval(checkInterval);
        }

      }, intervalTime);
    }

    // Call the function
    initZoomButtonForBed();


   

  

     // Example: when Zoom button is clicked
    $(document).on('click', '.tpo-zoom-btn', function() {
      
      const $btn = $(this);
      const value = $btn.siblings('.tpo_option_type_label_wrapper').find('.tpo_option_label').html().trim();
      var imageURL = '';
      switch(value){
        case 'Plain':
          imageURL = 'https://cdn.shopify.com/s/files/1/0864/9179/1672/files/Ottoman_Box_Plain_Full.png?v=1770047702';
        break;
        case 'Button':
          imageURL = 'https://cdn.shopify.com/s/files/1/0864/9179/1672/files/Ottoman_Box_Button_Full.png?v=1770047702';
        break;
        case 'Wood Trim':
          imageURL = 'https://cdn.shopify.com/s/files/1/0864/9179/1672/files/Ottoman_Box_Wood_Trim_Full.png?v=1770047702';
        break;
      }

      // Open the image in Magnific Popup
       if ($.magnificPopup) {
        $.magnificPopup.open({
          items: { src: imageURL },
          type: 'image',
          closeOnContentClick: true,
          closeBtnInside: true
        });
      } else {
        console.error('Magnific Popup is not loaded yet.');
      }

    });


if ($('body').hasClass('template-index')) {
   

    // Get current window width
    var windowWidth = $(window).width();

    // Initialize variable
    var video;

    // Use different selectors based on width
    if (windowWidth < 800) {
        // Mobile
        video = $('.image-mobile video')[0];
    } else {
        // Desktop
        video = $('.image-desktop video')[0];
    }


    var content = $('.slider-container .content'); // container
    var lastSegment = '';

    if (video && content.length) {

        video.addEventListener('timeupdate', function() {
            var currentTime = Math.floor(video.currentTime); // round to nearest second
            console.log('currentTime: ' + currentTime);

            var newH1 = '';
            var newLinkHtml = '';
            var newLinkHref = '';

            // Trigger changes only on specific seconds
            if (currentTime === 0) {
                newH1 = 'Discover unmatched luxury with Arabella designs';
                newLinkHtml = 'EXPLORE OUR SOFAS';
                newLinkHref = 'https://arabelladesigns.co.uk/pages/bespoke-luxury-sofas';
            } else if (currentTime === 5) {
                newH1 = 'Where bespoke design <span class="d-block">meets comfort</span>';
                newLinkHtml = 'EXPLORE OUR BAR STOOLS & CHAIRS';
                newLinkHref = 'https://arabelladesigns.co.uk/pages/chairs-bar-stools';
            } else if (currentTime === 11) {
                newH1 = 'Handcrafted for style <span class="d-block">& comfort</span>';
                newLinkHtml = 'EXPLORE OUR SOFAS';
                newLinkHref = 'https://arabelladesigns.co.uk/pages/bespoke-luxury-sofas';
            } else if (currentTime === 16) {
                newH1 = 'Designed to sit beautifully <span class="d-block">in your home</span>';
                newLinkHtml = 'EXPLORE OUR BAR STOOLS & CHAIRS';
                newLinkHref = 'https://arabelladesigns.co.uk/pages/chairs-bar-stools';
            }

            // Only animate if segment changed
            if (newH1 && newH1 !== lastSegment) {
                lastSegment = newH1;

                // Update h1 and link instantly
                content.find('h1').html(newH1);
                content.find('a.arabella-hero-btn').html(newLinkHtml).attr('href', newLinkHref);

                // Animate the whole content container
                content.stop(true, true)
                    .css({ opacity: 0.8, filter: 'blur(8px)', visibility: 'visible' });

                content[0].offsetHeight; // force reflow

                content.animate({ opacity: 1 }, {
                    duration: 2500,
                    step: function(now) {
                        $(this).css('filter', 'blur(' + (8 * (1 - now)) + 'px)');
                    }
                });
            }
        });
    }
}




  $(document).on('click', '.announcement-bar__right.desktop-only', function () {
    window.location.href = 'https://uk.trustpilot.com/review/arabelladesigns.co.uk';
  });


  // Only move on mobile
  if ($(window).width() <= 768) {
      var $price = $('.product-form .price-container');
      var $buttons = $('.buy-buttons-row');

      if ($price.length) {
          // Clone the price container and prepend the clone
          $price.clone().prependTo($buttons);
          
          setTimeout(function(){
              $('.buy-buttons-row .price-container').addClass('active');
          }, 2000);
      }
  }

      
});